import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import countryList from 'react-select-country-list';

import { get, map } from 'lodash-es';

import { fieldShape, selectionShape } from './index.shape';
import { getFormatOptionLabelDefault, getValue, styleCustom, themeCustom } from './index.utils';

import './index.scss';

/**
 * select component
 * @param props
 * @returns {XML}
 * @constructor
 */
const SelectCountry = props => {
  const {
    field: { name, value },
    selection,
    isMulti,
    placeholder,
    disabled,
    formatOptionLabel,
    width,
    existError,
    showError,
    eventEmitter,
    ...other
  } = props;

  const options = useMemo(() => countryList().getData(), []);

  const [valueLocal, setValueLocal] = useState(getValue({ value, isMulti, options }));

  const handleChangeLocal = selectedOption => {
    const fieldValue = isMulti ? map(selectedOption, option => get(option, 'value')) : get(selectedOption, 'value');
    //
    setValueLocal(getValue({ value: fieldValue, isMulti, options }));
    eventEmitter(fieldValue);
  };

  // TODO observable value
  useEffect(() => {
    setValueLocal(getValue({ value, isMulti, options }));
  }, [value]);

  return (
    <Select
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      className="coog-select"
      value={valueLocal}
      name={name}
      styles={styleCustom({ width, existError, showError })}
      theme={themeCustom({ existError, showError })}
      placeholder={placeholder}
      onChange={handleChangeLocal}
      formatOptionLabel={formatOptionLabel}
      options={options}
      isDisabled={disabled}
      isLoading={false}
      isMulti={isMulti}
    />
  );
};

SelectCountry.propTypes = {
  field: PropTypes.shape(fieldShape),
  selection: PropTypes.arrayOf(selectionShape).isRequired,
  isMulti: PropTypes.bool,
  formatOptionLabel: PropTypes.func,
  placeholder: PropTypes.string,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
};

SelectCountry.defaultProps = {
  field: {
    value: 'FR',
  },
  formatOptionLabel: getFormatOptionLabelDefault,
  disabled: false,
  width: undefined,
  existError: false,
  showError: false,
  isMulti: false,
  placeholder: '',
};

export default SelectCountry;
